export default "__VITE_ASSET__QyncgvnU__"